import "./archive-cr-edit-screen-header.scss"

import { defineComponent, PropType } from 'vue';

import { ArchiveResource, getTranslatedString } from "@skinsoft/types";
import { archiveSelectors, thesaurusTermSelectors } from "@skinsoft/selectors";

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { BasicArchiveCard } from "@skinsoft/ui2";

export const ArchiveCREditScreenHeader = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sBasicArchiveCard: BasicArchiveCard,
    },
    props: {
        archive: {
            type: Object as PropType<ArchiveResource>,
            required: true,
        },
    },
    template: require("./archive-cr-edit-screen-header.html"),
    data() {
        return {
            archiveTypes: '',
            institution: '',
            principalMediumType: '',
            materialImportance: '',
            isExtended: false,
        }
    },
    mounted() {
        this.updateArchiveTypes()
        this.updateInstitution()
        this.updatePrincipalMediumType()
        this.updateMaterialImportance()
    },
    computed: {
        path(): string {
            return archiveSelectors.path(this.archive) ?? ''
        },
    },
    methods: {
        async updateArchiveTypes() {
            const types = archiveSelectors.archiveTypes(this.archive)

            let res = ''
            const separator = " ; "

            if(types?.length) {
                for(const type of types) {
                    if(type?.archiveType) {
                        const thesaurusTermId = (type.archiveType as any).ref ?? type.archiveType
                        const thesaurusTerm = await this.$thesaurusTermDataStore.fetchOne(thesaurusTermId).toPromise()
                        if(thesaurusTerm) {
                            const thesaurusTermTranslatedString = thesaurusTermSelectors.preferredTerm(thesaurusTerm)
                            if(thesaurusTermTranslatedString) {
                                const thesaurusTermValue = getTranslatedString(
                                    thesaurusTermTranslatedString,
                                    this.$i18n.locale
                                )
                                if(thesaurusTermValue) {
                                    res += `${thesaurusTermValue}${separator}`
                                }
                            }
                        }
                    }
                }
            }

            if(res.length) {
                res = res.slice(0, -separator.length)
            }
            this.archiveTypes = res
        },

        async updateInstitution() {
            let res = ''

            const institutionId = archiveSelectors.institution(this.archive)

            if(institutionId) {
                const institutionName = await this.$institutionDataStore.getInstitutionName(
                    institutionId,
                    this.getAppLocale()
                ).toPromise()

                if(institutionName) {
                    res = institutionName
                }
            }

            this.institution = res
        },

        async updatePrincipalMediumType() {
            const mediumType = archiveSelectors.principalMediumType(this.archive)

            if(mediumType) {
                const thesaurusTerm = await this.$thesaurusTermDataStore.fetchOne(mediumType).toPromise()
                if(thesaurusTerm) {
                    const thesaurusTermTranslatedString = thesaurusTermSelectors.preferredTerm(thesaurusTerm)
                    if(thesaurusTermTranslatedString) {
                        const thesaurusTermValue = getTranslatedString(
                            thesaurusTermTranslatedString,
                            this.$i18n.locale
                        )
                        if(thesaurusTermValue) {
                            this.principalMediumType = thesaurusTermValue
                        }
                    }
                }
            }
        },

        async updateMaterialImportance() {
            const translatedString = archiveSelectors.materialImportance(this.archive)

            if(translatedString) {
                this.materialImportance = getTranslatedString(
                    translatedString,
                    this.getAppLocale(),
                )
            }
        },

        toggleCollapsableSection() {
            this.isExtended = !this.isExtended
        },
    },
})
